import css from "styled-jsx/css";
import { grid } from "../constants";

export default css`
:global(.streaming-header) :global(.main-title) {
  padding-top: 1.5rem;
  padding-bottom: 1.25rem;
  line-height: 2rem;
}
:global(.streaming-header) :global(.sub-title) {
  padding-right: min(4rem, 6vw);
  padding-left: min(4rem, 6vw);
}

@media screen and (min-width: ${grid.breakpoint_sm}px) {
  :global(.streaming-header) :global(.main-title) {
    padding-top: 2rem;
  }
}
@media screen and (min-width: ${grid.breakpoint_md}px) {
  :global(.streaming-header) :global(.main-title) {
    padding-top: 2.5rem;
  }
}
`;
